export const DATE_FORMATS= {
  YYYY_MM_DD_HH_MM_SS : 'yyyy-mm-dd hh:mm:ss',
}

export const TIMES = {
  ONE_HOUR: 3600000
}

export class DateTool {

  static formatDate(d: Date, format: string){
    switch (format){
      case DATE_FORMATS.YYYY_MM_DD_HH_MM_SS:
        return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()} ${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
    }
  }
}
